import React from 'react';

export default function SVG(props) {
  return (
    <svg className={`svg-icon icon-${props.icon} ${props.className || ''}`} xmlns="http://www.w3.org/2000/svg">
      <use xlinkHref={`#reuse-${props.icon}`}></use>
    </svg>
  )
}